import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { UserDetails } from '../types';

interface AvatarProps {
    height?: number;
    userDetails: UserDetails | null;
    showTooltip?: boolean;
    className?: string;
    onClick?: () => void;
}

const Avatar: React.FC<AvatarProps> = ({
    userDetails,
    height = 28,
    showTooltip = true,
    className = '',
    onClick,
}) => {
    const styleParams = {
        height: `${height}px`,
        width: `${height}px`,
        borderRadius: `${height / 2}px`,
        cursor: onClick ? 'pointer' : 'default',
    };

    const userName = userDetails
        ? `${userDetails.first_name} ${userDetails.last_name}`
        : 'Unknown User';

    const avatarContent = userDetails?.avatar_url ? (
        <img
            className={`avatar ${className}`}
            src={userDetails.avatar_url}
            alt={userName}
            style={styleParams}
            onClick={onClick}
        />
    ) : (
        <div
            className={`avatar unknown ${className}`}
            style={{
                ...styleParams,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#e0e0e0',
                color: '#757575',
            }}
            onClick={onClick}
        >
            <p
                style={{
                    fontSize: `${height / 2}px`,
                    margin: 0,
                    fontWeight: 'bold',
                }}
            >
                {userDetails ? userDetails.first_name.charAt(0) : '?'}
            </p>
        </div>
    );

    if (!showTooltip) {
        return avatarContent;
    }

    return (
        <Tooltip
            title={
                <p
                    style={{
                        margin: '0px',
                        fontSize: '1.2em',
                    }}
                >
                    {userName}
                </p>
            }
            placement="bottom"
        >
            {avatarContent}
        </Tooltip>
    );
};

export default Avatar;
